import { createStyles, Theme } from '@zn-material-ui'

export default (theme: Theme) =>
  createStyles({
    root: {
      '& button': {
        marginLeft: 60,
      },
    },
    flexContainer: {
      width: '100%',
      margin: 'auto',
    },
    childContentWrap: {
      minWidth: '760px',
      marginTop: '114px',
    },
    fixedTab: {
      height: '50px',
      width: '100%',
      position: 'fixed',
      top: '64px',
      zIndex: theme.zIndex.appBar - 1,
    },
    notTabs: {
      marginTop: '1px !important',
    },
    home: {
      width: '100%',
      height: '900px',
    },
    routeChildrenWrap: {
      width: '1200px',
      display: 'flex',
      justifyContent: 'center',
      margin: '21px auto 0',
    },
    pic: {
      width: '100%',
      height: '100%',
    },
    bayWindow: {
      width: '200px',
      height: '90px',
      position: 'fixed',
      top: 0,
      left: 0,
      cursor: 'pointer',
      zIndex: 1000,
    },
    delete: {
      width: '24px',
      height: '24px',
      background: '#ffff',
      opacity: 0.7,
      position: 'absolute',
      top: 0,
      right: 0,
      cursor: 'pointer',
    },
  })
